export const togglebutton = {
  colorScheme: {
    light: {
      root: {
        hoverColor: '{neutral.700}',
        hoverBackground: '{primary.300}',
      },
      background: '#eef4f7',
      color: '#0e2a4a',
      icon: {
        color: '#0e2a4a',
        hoverColor: '{neutral.700}',
      },
      checked: {
        background: '#eef4f7',
      },
    },
    dark: {
      root: {
        hoverColor: '{neutral.100}',
        hoverBackground: '{primary.500}',
      },
      background: '#3C434F',
      color: '#ffffff',
      icon: {
        color: '#ffffff',
        hoverColor: '{neutral.100}',
      },
      checked: {
        background: '{surface.500}',
      },
    },
  },
};
